import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionRegistryOptionWithQuestionState } from './ConditionsOptionCombined';
import { ConditionsOptionOther } from './ConditionsOptionOther';
import { ConditionsMultipleChoiceGap } from './ConditionsMultipleChoiceGap';
export class ConditionsMultipleChoice extends ConditionRegistryCategory {
    label = 'MultipleChoice';
    c_optionWithQuestionState = new ConditionRegistryOptionWithQuestionState(this);
    c_optionOther = new ConditionsOptionOther(this);
    c_gap = new ConditionsMultipleChoiceGap(this);
}
